//
// ConditionReference.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../BIRDModel";
import "../conditions/Condition";
import "../conditions/AlertableState";
import "../conditions/GraphConditionUsage";
import "./ConditionParameter";
import "../conditions/ConditionScopes";

var ConditionReference = createModule("BIRD::ConditionReference", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        condition: 1,
        hidden: 2,
        alertableStates: [1],
        applyToVariable: 7,
        nonVisual: 2,
        attrMap: 7,
        parameters: [1],
        graphUsage: 1,
        conditionScopes: 1,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default ConditionReference;
